import { AfterViewInit, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import Highcharts from 'highcharts';
import { VintageChartArraysMA } from 'src/app/domain/market-analysis/dto/MaByIndustryChartDTO';
import { CHART_COLORS, CHART_FONTS, CHART_STYLES }
  from 'src/app/domain/shared/component/pie-chart-simple/highcharts-common/highcharts-global-const';

@Component({
  selector: 'app-moic-vintage-chart',
  templateUrl: './moic-vintage-chart.component.html',
  styleUrls: ['./moic-vintage-chart.component.scss'],
})

export class MoicVintageChartComponent implements AfterViewInit, OnChanges {

  @Input() chartName;
  @Input() selectedFundName: string;
  @Input() data: VintageChartArraysMA;

  chartType = 'line';
  typeOfChart: string;
  options: any;


  ngAfterViewInit(): void {
    this.renderChart();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.returnOptions();
    if (this.data && changes.data) {
      this.collectData();
      this.renderChart();
    }
  }

  returnOptions(): void {
    this.typeOfChart = this.chartName.split(' ')[1];
    this.options = {
      title: {
        text: this.chartName,
        align: 'left',
        style: CHART_STYLES.title,
      },
      xAxis: [{
        labels: CHART_STYLES.xAxisLabels,
        categories: [],
        type: 'category',
        crosshair: true,
        title: {
          text: 'Vintage',
          style: { color: CHART_COLORS.black12, fontSize: CHART_FONTS.font3 },
        },
      }],
      yAxis: [{
        title: {
          text: this.typeOfChart,
          style: { color: CHART_COLORS.black12, fontSize: CHART_FONTS.font3 },
        },
        labels: {
          style: { color: CHART_COLORS.black12, fontSize: CHART_FONTS.font4 },
        },
      }],
      tooltip: CHART_STYLES.maVintageTooltip(this.typeOfChart),
      navigation: CHART_STYLES.navigation,
      credits: {
        enabled: false,
      },
      legend: CHART_STYLES.legend('right', true),
      plotOptions: {
        series: {
          lineWidth: 0, // hide the line, needed to show one tooltip for all series, but without line
          marker: {
            enabled: true,
          },
          states: {
            hover: {
              lineWidthPlus: 0,
            },
          },
        },
      },
      series: [
        {
          name: 'Top 25%',
          color: CHART_COLORS.green,
          type: this.chartType,
          marker: {
            symbol: 'triangle',
            radius: 6,
          },
        },
        {
          name: 'Median',
          color: CHART_COLORS.black9,
          type: this.chartType,
          marker: {
            radius: 6,
          },
        },
        {
          name: 'Bottom 25%',
          color: CHART_COLORS.brightOrange,
          type: this.chartType,
          marker: {
            symbol: 'triangle-down',
            radius: 6,
          },
        },
        {
          name: this.selectedFundName,
          color: CHART_COLORS.vibrantMagenta,
          type: this.chartType,
          marker: {
            radius: 6,
          },
        },
      ],
      lang: CHART_STYLES.lang,
    };
  }

  collectData(): void {
    this.options.series[0].data = this.data.topArr;
    this.options.series[1].data = this.data.medianArr;
    this.options.series[2].data = this.data.bottomArr;
    this.options.series[3].data = this.data.selectedFundArr;
    this.options.xAxis[0].categories = this.data.periodsArr;
    // check the values in the selectedFundArr, to choose the legend name (fundName or 'No data')
    if (this.data.selectedFundArr && this.data.selectedFundArr.length > 0) {
      this.options.series[3].name = this.data.selectedFundArr.every((value) => value === null) ? 'No data' : this.selectedFundName;
    }
  }

  private renderChart(): void {
    if (document.getElementById(this.chartName)) {
      Highcharts.chart(this.chartName, this.options);
    }
  }
}
